import React from 'react';
import '../../styles/ftux.scss';
import IconContainer from '../../../../common-components/FtuxComponent/IconContainer';

const LibraryFtux = () => {
  return (
    <div className="sl-library-ftux-container">
      <IconContainer icon="🎥" bgColor="#EEEEEE" />
      <div style={{ maxWidth: '440px' }}>
        <div className="sl-library-ftux-title">No Libraries Created</div>
        <div className="sl-library-ftux-sub-title">
          Once you add labels to posts in campaigns, you can sort them into libraries to organize content.
        </div>
      </div>
    </div>
  );
};

export default LibraryFtux;
